const localizeCurrency = (price, countryCode) => {
  let localizedCurrencyCode = 'EUR'
  if (price.localizedPrices) {
    const localizedPrice = price.localizedPrices.find(v => v.country_codes.includes(countryCode))
    if (localizedPrice) {
      localizedCurrencyCode = localizedPrice.unit_price.currency_code
    }
  }

  return localizedCurrencyCode
}

export default localizeCurrency
